import { render, staticRenderFns } from "./TripDetailFooterButton.vue?vue&type=template&id=37289e01&"
import script from "./TripDetailFooterButton.vue?vue&type=script&lang=ts&"
export * from "./TripDetailFooterButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports